import { useClient } from '../../../../util/hooks';

export function useClientData() {
  const { client: data, clientLoading: isLoading } = useClient();
  return { data, isLoading };
}
